import { render } from "./selectDateForm.vue?vue&type=template&id=0667024c"
import script from "./selectDateForm.vue?vue&type=script&lang=js"
export * from "./selectDateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__